import { ca } from '@cian/analytics';

import { IThunkActionCreator } from '../../types/store';
import { getTrackingObject } from '../../utils/analytics';

export function trackShowCallBuilderPopup(): IThunkActionCreator {
  return (dispatch, getState) => {
    const state = getState();

    ca('eventSite', {
      name: 'oldevent',
      category: 'Card_KP',
      action: 'Show_KP_popup',
      label: 'Question_to_developer',
      ...getTrackingObject(state),
    });
  };
}

export function trackCallBuilderPopupCadastreLinkClick(url: string): IThunkActionCreator {
  return (dispatch, getState) => {
    const state = getState();

    ca('eventSite', {
      name: 'oldevent',
      category: 'KP_popup',
      action: 'ExitLinkClick',
      label: url,
      ...getTrackingObject(state),
    });
  };
}
